import {NOT_FOUND, UNSPECIFIED} from '../../../consts';

function AttributeItem (label, value) {
  this.label = label;
  this.value = value;
}

AttributeItem.prototype.getLabel = function () {
  return this.label;
};

AttributeItem.prototype.getValue = function () {
  return this.value;
};

AttributeItem.prototype.isActive = function () {
  return this.value !== UNSPECIFIED && this.value !== NOT_FOUND;
};

export default AttributeItem;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/attributeItem.js